/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetLanguages200ResponseInner
 */
export interface GetLanguages200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetLanguages200ResponseInner
     */
    language: string;
    /**
     * 
     * @type {number}
     * @memberof GetLanguages200ResponseInner
     */
    translated: number;
    /**
     * 
     * @type {number}
     * @memberof GetLanguages200ResponseInner
     */
    total: number;
    /**
     * 
     * @type {string}
     * @memberof GetLanguages200ResponseInner
     */
    from?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetLanguages200ResponseInner
     */
    _default: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetLanguages200ResponseInner
     */
    enabled: boolean;
}

/**
 * Check if a given object implements the GetLanguages200ResponseInner interface.
 */
export function instanceOfGetLanguages200ResponseInner(value: object): value is GetLanguages200ResponseInner {
    if (!('language' in value) || value['language'] === undefined) return false;
    if (!('translated' in value) || value['translated'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('_default' in value) || value['_default'] === undefined) return false;
    if (!('enabled' in value) || value['enabled'] === undefined) return false;
    return true;
}

export function GetLanguages200ResponseInnerFromJSON(json: any): GetLanguages200ResponseInner {
    return GetLanguages200ResponseInnerFromJSONTyped(json, false);
}

export function GetLanguages200ResponseInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetLanguages200ResponseInner {
    if (json == null) {
        return json;
    }
    return {
        
        'language': json['language'],
        'translated': json['translated'],
        'total': json['total'],
        'from': json['from'] == null ? undefined : json['from'],
        '_default': json['default'],
        'enabled': json['enabled'],
    };
}

export function GetLanguages200ResponseInnerToJSON(json: any): GetLanguages200ResponseInner {
    return GetLanguages200ResponseInnerToJSONTyped(json, false);
}

export function GetLanguages200ResponseInnerToJSONTyped(value?: GetLanguages200ResponseInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'language': value['language'],
        'translated': value['translated'],
        'total': value['total'],
        'from': value['from'],
        'default': value['_default'],
        'enabled': value['enabled'],
    };
}

